module.exports = __webpack_public_path__ + "static/img/collage 2.8ce5122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collage 2.jpg
// module id = XNco
// module chunks = 0